<!-- BACKDROP -->
@if (isOpened()) {
  <div
    class="fixed inset-0 z-40 bg-black/40"
    (click)="close()"
    (keydown)="close()"
  ></div>
}

<!-- MOBILE SLIDE-UP NAV -->
<div
  class="fixed bottom-0 left-0 right-0 z-50 bg-white text-[#00334C] text-lg leading-[28px] h-[90vh] rounded-t-xl transition-transform duration-300 ease-out lg:hidden"
  [ngClass]="{
    'translate-y-full': !isOpened(),
    'translate-y-0': isOpened(),
  }"
>
  @if (!isDesktop() && showGlobalSearch()) {
    <div class="flex items-center px-2 py-3 border-b">
      <div
        class="flex items-center gap-2 rounded-full px-1 py-2 w-full text-[16px]"
      >
        <div class="w-full" embedMicroapp appName="global-search"></div>
      </div>
    </div>
  }

  <!-- NAV CONTENT -->
  <div class="overflow-y-auto h-[calc(90vh-56px)] font-bold" (click)="close()">
    <ng-content></ng-content>
  </div>
</div>
